import React, { useState } from 'react';
import './SuggestCorrectionModal.css';

const FIELD_OPTIONS = [
  'Price',
  'Service name',
  'Category',
  'Unit',
  'Date',
  'Hospital name',
  'Location',
  'Other'
];

const SuggestCorrectionModal = ({ correctionTarget, onClose }) => {
  const [field, setField] = useState(correctionTarget?.field || 'Price');
  const [suggestedValue, setSuggestedValue] = useState('');
  const [note, setNote] = useState('');
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  if (!correctionTarget) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setStatus(null);

    try {
      const response = await fetch('/api/corrections', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify({
          ...correctionTarget,
          field,
          suggestedValue,
          note
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Unable to send correction.');
      }

      setStatus({ type: 'success', message: 'Correction submitted for review.' });
      setSuggestedValue('');
      setNote('');
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="correction-modal-backdrop">
      <div className="correction-modal" role="dialog" aria-modal="true" aria-labelledby="correction-modal-title">
        <div className="correction-modal-header">
          <div>
            <h2 id="correction-modal-title">Suggest a correction</h2>
            <p>{correctionTarget.label}</p>
          </div>
        </div>

        {status && (
          <div className={`correction-status correction-status-${status.type}`} role="status">
            {status.message}
          </div>
        )}

        <form className="correction-form" onSubmit={handleSubmit}>
          <label>
            What is wrong?
            <select value={field} onChange={event => setField(event.target.value)}>
              {FIELD_OPTIONS.map(option => <option key={option} value={option}>{option}</option>)}
            </select>
          </label>

          <div className="correction-current-value">
            <span>Current value</span>
            <strong>{correctionTarget.currentValue || 'Not listed'}</strong>
          </div>

          <label>
            Suggested correction
            <input
              type="text"
              value={suggestedValue}
              onChange={event => setSuggestedValue(event.target.value)}
              placeholder="Enter the correct value"
              required
            />
          </label>

          <label>
            Optional note
            <textarea
              value={note}
              onChange={event => setNote(event.target.value)}
              placeholder="Add context, such as where you saw the correct value on the document."
              rows="3"
            />
          </label>

          <div className="correction-actions">
            <button type="button" className="secondary-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="next-btn" disabled={saving || !suggestedValue.trim()}>
              {saving ? 'Sending...' : 'Submit correction'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuggestCorrectionModal;
